// Google Analytics 4 helpers — every call is a safe no-op if the tag hasn't
// loaded (ad blockers, script failures) so shopping never breaks.
export const gtag = (...args) => {
  if (typeof window !== "undefined" && window.gtag) window.gtag(...args);
};

export const gTrack = (event, params = {}) => gtag("event", event, params);
